import { Button } from '@/common/ui/button'
import { Plus } from 'lucide-react'
import { Link } from 'react-router-dom'
import TournamentTable from '@/modules/tournament/components/TournamentTable'
import TournamentPresetGallery from '@/modules/tournament/components/TournamentPresetGallery'
import type { components } from '@/schema'

type Tournament = components['schemas']['AdminTournamentResponse']

interface TournamentListingProps {
	data: Tournament[]
	total: number
	isLoading: boolean
}

export default function TournamentListing({
	data,
	total,
	isLoading,
}: TournamentListingProps) {
	return (
		<div className="space-y-6">
			<div className="flex items-center justify-between">
				<h2 className="text-2xl font-semibold">
					จัดการทัวร์นาเมนต์ ({total} รายการ)
				</h2>
				<Button asChild>
					<Link to="/operator/tournaments/create">
						<Plus className="mr-2 h-4 w-4" />
						สร้างทัวร์นาเมนต์ใหม่
					</Link>
				</Button>
			</div>

			<TournamentPresetGallery />

			<TournamentTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
